// 

// (function ($) {
//   $(document).ready(function () {
//     if($('.full-width-content-with-image-slider').length> 0){
//     // Add active class after a short delay
//     setTimeout(function () {
//       $(".full-width-content-with-image-slider").addClass("active");

//       // Initialize Slick slider if multiple content cards


//       if ($(".full-width-content-with-image-slider .content-card").length > 1) {

//         $(".full-width-content-with-image-slider .slide-wrapper").slick({
//           autoplay: true,
//           autoplaySpeed: 5000,
//           dots: true,
//           arrows: false,
//           infinite: true,
//           speed: 500,
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           adaptiveHeight:false,
//           cssEase: "linear",
//           fade: true,
//           responsive: [
//             {
//               breakpoint: 1024,
//               settings: {
//                 slidesToShow: 1,
//                 adaptiveHeight: true 
//               }
//             }
//           ]
//         });
//       }

//       // Check counters immediately after active is added
//       checkAndRunCounters();
//     }, 200);

//     // Counter animation
//     const runCounters = () => {
//       $(".active.full-width-content-with-image-slider .count-wrap").each(function () {
//         const $counter = $(this);
//         const target = parseInt($counter.data("target"), 10) || 0;
//         const suffix = $counter.data("suffix") || "";
//         const speed = 200; // smaller = faster
//         let count = 0;
//         const increment = Math.ceil(target / speed);

//         const updateCount = () => {
//           count += increment;
//           if (count < target) {
//             $counter.text(count + suffix);
//             requestAnimationFrame(updateCount);
//           } else {
//             $counter.text(target + suffix);
//           }
//         };

//         $counter.text("0" + suffix);
//         updateCount();
//       });
//     };

//     // Check if element is in viewport
//     const isInViewport = ($el) => {
//       const rect = $el[0].getBoundingClientRect();
//       return rect.top < window.innerHeight && rect.bottom > 0;
//     };

//     let hasRun = false;

//     // Function to check and run counters once
//     const checkAndRunCounters = () => {
//       const $section = $(".full-width-content-with-image-slider.active");
//       if ($section.length && isInViewport($section) && !hasRun) {
//         runCounters();
//         hasRun = true;
//       }
//     };

//     // Check counters on scroll & resize
//     $(window).on("scroll resize", checkAndRunCounters);}
//   });
//   if ($(".full-width-content-with-image-slider .content-card").length > 1 && $(window).width() > 1024) {
//     $('.full-width-content-with-image-slider .content-card').matchHeight();
//   }
//   $(window).on('resize', function () {
//     if ($(window).width() > 1024) {
//       $('.full-width-content-with-image-slider .content-card').matchHeight() ;// reapply heights
//     } 
//   });
// })(jQuery);


(function ($) {
  $(document).ready(function () {
    if ($(".full-width-content-with-image-slider").length > 0) {
      $(".full-width-content-with-image-slider").each(function (index) {
        const $section = $(this);
        const $cards = $section.find(".content-card");
        const $slider = $section.find(".slide-wrapper");

        // Assign a unique group name for matchHeight
        const groupName = "slider-group-" + index;

        // Activate section with delay
        setTimeout(function () {
          $section.addClass("active");

          // Initialize Slick only if more than one content card
          if ($cards.length > 1) {
            $slider.slick({
              autoplay: true,
              autoplaySpeed: 5000,
              dots: true,
              arrows: false,
              infinite: true,
              speed: 500,
              slidesToShow: 1,
              slidesToScroll: 1,
              adaptiveHeight: false,
              cssEase: "linear",
              fade: true,
              responsive: [{
                breakpoint: 1024,
                settings: {
                  slidesToShow: 1,
                  adaptiveHeight: true,
                },
              }, ],
            });
          }

          // Initialize counters for this section
          checkAndRunCounters($section);
        }, 200);

        // Counter logic (scoped)
        const runCounters = () => {
          $section.find(".count-wrap").each(function () {
            const $counter = $(this);
            // Check if parent .content-card has .stop-couter class
            if ($counter.closest('.content-card').hasClass('stop-counter')) {
              // Do not animate, just set to target value immediately
              const target = parseInt($counter.data("target"), 10) || 0;
              const suffix = $counter.data("suffix") || "";
              $counter.text(target + suffix);
              return; // skip animation
            }
            const target = parseInt($counter.data("target"), 10) || 0;
            const suffix = $counter.data("suffix") || "";
            const speed = 200; // smaller = faster
            let count = 0;
            const increment = Math.ceil(target / speed);

            const updateCount = () => {
              count += increment;
              if (count < target) {
                $counter.text(count + suffix);
                requestAnimationFrame(updateCount);
              } else {
                $counter.text(target + suffix);
              }
            };

            $counter.text("0" + suffix);
            updateCount();
          });
        };

        // Check if section in viewport
        const isInViewport = ($el) => {
          const rect = $el[0].getBoundingClientRect();
          return rect.top < window.innerHeight && rect.bottom > 0;
        };

        let hasRun = false;

        const checkAndRunCounters = () => {
          if (isInViewport($section) && !hasRun) {
            runCounters();
            hasRun = true;
          }
        };

        // Run on scroll & resize
        $(window).on("scroll resize", function () {
          checkAndRunCounters($section);
        });

        // MatchHeight for desktop only, scoped per section
        const applyMatchHeight = () => {
          if ($cards.length > 1 && $(window).width() > 1024) {
            $cards.matchHeight({
              byRow: false,
              group: groupName,
            });
          } else {
            // Remove matchHeight when not needed
            $cards.css("height", "auto");
          }
        };

        applyMatchHeight();

        $(window).on("resize", function () {
          applyMatchHeight();
        });
      });
    }
  });
})(jQuery);